export default __webpack_public_path__ + "static/media/1865.77394b52.png";